import { RootState } from '../../../../app/store/configureStore';
import { tableSelectors } from './tableSlice';

export const selectRestaurantTables = (state: RootState) =>
  tableSelectors.selectAll(state);

export const selectRestaurantTableById =
  (tableId: string) => (state: RootState) =>
    tableSelectors.selectById(state, tableId);

export const selectQrCode = (state: RootState) => state.tables.qrCode;

export const selectSelectedTable = (state: RootState) =>
  state.tables.selectedTable;

export const selectTableStatus = (state: RootState) => state.tables.status;
